import React from "react";
import styles from "./index.module.scss";

export default function InfoTags({
  value,
  title
}: Readonly<{
  value: string;
  title: string;
}>) {
  return (
    <div>
      <div className={styles.FlipperVaultCardInfoItemTitle}>{title}</div>
      <div className={styles.FlipperVaultCardInfoItemValue}>{value}</div>
    </div>
  );
}
